import { warningColor, successColor, dangerColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const trackingComplaintStyle = () => ({
	loaderWrapper: {
		position: 'absolute',
		zIndex: 100,
		height: '100%',
		width: '100%',
		borderRadius: 8,
		'& > div': {
			height: '100%',
		},
	},
	ticketTrackingContentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	trackTicketContent: {
		paddingTop: 24,
		width: 300,
	},
	trackTicketErrorWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	},
	trackTicketErrorTextWrapper: {
		maxWidth: 235,
		textAlign: 'center',
	},
	oval: {
		width: 56,
		height: 56,
		borderRadius: '100%',
		position: 'relative',
		marginBottom: 24,
		marginLeft: 'auto',
		marginRight: 'auto',
		'& > *': {
			width: 38,
			height: 38,
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			justifyContent: 'center',
			display: 'flex',
			alignItems: 'center',
			fontSize: 30,
		},
	},
	ovalError: {
		border: `solid 3px ${dangerColor[0]}`,
		color: dangerColor[0],
	},
	ovalSuccess: {
		border: `solid 3px ${successColor[0]}`,
		color: successColor[0],
	},
	ovalWarning: {
		border: `solid 3px ${warningColor[0]}`,
		color: warningColor[0],
	},
	trackTicketErrorSubheaderWrapper: {
		paddingTop: 8,
	},
	trackTicketTextWrapper: {
		maxWidth: 254,
		'& a': {
			color: primaryColor[0],
		},
	},
	trackTicketInputContainer: {
		paddingTop: 30,
	},
	trackTicketButtonContainer: {
		textAlign: 'right',
		paddingTop: 20,
	},
	ticketWrapper: {
		textAlign: 'center',
	},
	ticketHeaderWrapper: {
		paddingTop: 4,
		paddingBottom: 24,
	},
	ticketStatus: {
		paddingTop: 8,
		paddingBottom: 24,
		maxWidth: 250,
	},
	moreInformationWrapper: {
		maxWidth: 245,
		paddingTop: 24,
	},
	trackAnotherContainer: {
		paddingTop: 30,
	},
	trackAnother: {
		bottom: 0,
		border: '0px',
		position: 'relative',
		margin: 'auto',
	},
	cardBody: {
		padding: '24px 24px 48px 24px',
	},
	descriptionWrapper: {
		paddingBottom: 24,
		maxWidth: 250,
	},
});

export default trackingComplaintStyle;
